import React, { Component } from "react";
import { withRouter } from "next/router";
import { NextSeo } from "next-seo";
import { seoFunct } from "../src/config/next-seo.config";
import HomeNav from "../src/pages/Home/HomeNav";
import HomeFooter from "../src/pages/Home/HomeFooter";
import RevampTermsAndConditions from "../src/pages/TermsAndConditions/RevampTermsAndConditions";

class TermsAndConditions extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<>
				<NextSeo {...seoFunct("TermsAndConditionsSeo")} />

				<HomeNav />
				<RevampTermsAndConditions />
				<HomeFooter />
			</>
		);
	}
}

export default withRouter(TermsAndConditions);
